import React from 'react';

interface AlertProps {
  variant?: string;
  className?: string;
  children?: React.ReactNode;
}

function Alert({ variant, className = '', children }: AlertProps) {
  const variantMap: Record<string, string> = {
    secondary: 'alert-info',
    danger: 'alert-error',
    warning: 'alert-warning',
    success: 'alert-success',
  };
  const variantClass = variant ? (variantMap[variant] || '') : '';
  return (
    <div className={'w-full ' + `alert ${variantClass} ${className}`.trim()} role="alert">
      {children}
    </div>
  );
}

export default Alert;
